import { lazy } from 'react';
import { useLoadAdminDependencies } from 'ProtectedRoute/useLoadAdminDependencies';

// Lazy, so the MBA admin sections load only when an admin opens the page, as they did inside the admin bundle.
const AdminMbaIndex = lazy(() => import(/* webpackPrefetch: true */ 'AdminMbaIndex'));

export function AdminMba() {
    // The sections read Angular models, such as Cohort, that the admin bundle registers.
    useLoadAdminDependencies();
    return <AdminMbaIndex />;
}
